import { createMiddleware } from "@tanstack/react-start";
import { getAccessToken } from "@/lib/api/client";

// Must be registered as a global `functionMiddleware` in `src/start.ts`
export const attachAuth = createMiddleware({ type: "function" }).client(async ({ next }) => {
  const token = getAccessToken();
  return next({
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
});
